import React from 'react';
import '../styles/EnConstruction.css';
import MainButton from '../components/MainButton';
import { useNavigate } from 'react-router-dom';

// Page en construction
const EnConstruction: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className='enconstruction-container'>
            <div className='enconstruction-icon'>🚧</div>
            <h1> Page en Construction</h1>
            <p>Cette page est actuellement en développement. Revenez bientôt!</p>

            <MainButton
                text="Retour à l'accueil"
                backgroundColor='tertiary'
                onClick={() => {
                    navigate('/');
                }}
            />
        </div>
    );
};

export default EnConstruction;
